import type { IGetUserProfileResponse } from '../../../repositories/chats/entities/user_profile/GetUserProfileResponse';
import type { IChatProfile } from '../../../types/chatProfile';
import { ERequestApiStatus } from '../../../types/appState';
import { hasClientInfoContent } from '../../../utils/hasClientInfoContent';
import { mapClientInfo } from './mapClientInfo';

export const mapResponse200 = (response: IGetUserProfileResponse): IChatProfile => {
  const clientInfo = mapClientInfo(response.clientInfo);

  // Ручка может ответить успехом, но без профиля или с полностью пустыми блоками.
  // Это не ошибка, но и показывать нечего — отражаем это отдельным статусом,
  // чтобы потребителям не приходилось заново разбирать содержимое ответа.
  if (!hasClientInfoContent(clientInfo)) {
    return {
      clientInfo: null,
      status: ERequestApiStatus.Empty,
    };
  }

  return {
    clientInfo,
    status: ERequestApiStatus.Succeed,
  };
};
